import services from 'services/module';
import { HttpSvcFactory } from 'services/HttpSvc';

export class EmbedsSvc {
    constructor(private HttpSvc: HttpSvcFactory) {}

    getEmbeds() {
        return this.HttpSvc<anm.UserEmbeds>('profile/stats/embed').secureGet();
    }
}

services.service('embedSvc', EmbedsSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/EmbedsSvc.ts